import {useMemo} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {CROPS} from "../utils/enumItemsUtils";
import {Crop} from "../types/domain/crop";
import {useQuery} from "@tanstack/react-query";
import {getCropIds} from "../services/fieldService";
import {queryClient} from "../utils/queryClient";

export const useCrops = () => {
    const {t} = useTranslation();

    return useMemo(() => {
        const crops: Crop[] = CROPS.map((item) => ({id: item.id, name: t(`enumerations.crops.${item.i18nKey}`)}));

        return {
            crops,
            cropsById: _.keyBy(crops, "id"),
        };
    }, [t]);
};

export const useCompanyCrops = (companyId?: string) => {
    const {t} = useTranslation();
    return useQuery({
        queryKey: ["companyCrops", companyId],
        queryFn: async () => {
            if (!companyId) return [];

            const crops = await getCropIds(companyId);
            return crops.map((cropId) => {
                const crop = CROPS.find((CROP) => CROP.id === cropId);
                return {id: cropId, name: t("enumerations.crops." + crop?.i18nKey) ?? ""};
            });
        },
        enabled: !!companyId,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};

export const invalidateCropsQueries = (companyId: string) =>
    void queryClient.invalidateQueries({queryKey: ["companyCrops", companyId]});
